import gql from "graphql-tag";

export function territoryListQuery(params) {
    return {
        query: gql`
            query($searchText: String) {
                result: territories(searchText: $searchText) {
                    id
                    name
                    code
                }
            }
        `,
        variables: params,
    };
}
